/** Minimal event bus for the modal registry. */
const listeners = {};

export const modalBus = {
	on(event, fn) {
		(listeners[event] = listeners[event] || []).push(fn);
	},
	off(event, fn) {
		listeners[event] = (listeners[event] || []).filter((f) => f !== fn);
	},
	emit(event, payload) {
		(listeners[event] || []).forEach((fn) => fn(payload));
	},
};
